// redux/actions/usuarios/usuarios.js
import axios from "axios";
import {
  FETCH_USUARIOS_FAILURE,
  FETCH_USUARIOS_SUCCESS,
} from "./types";
import { PATH } from "../../utils";

const SESSION_EXPIRED = "SESSION_EXPIRED";
const API_BASE = `${PATH}`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenadmin");
};

const handleApiError = (dispatch, error, fallbackMsg) => {
  if (error?.response?.status === 401) {
    clearTokens();
    if (dispatch) dispatch({ type: SESSION_EXPIRED });
    return "Tu sesión ha expirado. Autentícate nuevamente.";
  }
  return (
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.message ||
    fallbackMsg
  );
};

const fetchUsuariosSuccess = (payload) => ({
  type: FETCH_USUARIOS_SUCCESS,
  payload,
});

const fetchUsuariosFailure = (message) => ({
  type: FETCH_USUARIOS_FAILURE,
  payload: { error: message },
});

export const actionUsuariosGet = (params = {}) => {
  return async (dispatch) => {
    try {
      const resp = await api.get("users", {
        params,
        headers: authHeader(),
      });
      dispatch(fetchUsuariosSuccess(resp.data));
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "Error al cargar usuarios");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

export const actionUsuarioCreate = (payload) => {
  return async (dispatch) => {
    try {
      const resp = await api.post("users", payload, { headers: authHeader() });
      await dispatch(actionUsuariosGet());
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo crear el usuario");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

export const actionUsuarioGetById = (id) => {
  return async (dispatch) => {
    try {
      const resp = await api.get(`users/id/${id}`, { headers: authHeader() });
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo obtener el usuario");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

export const actionUsuarioUpdateById = (id, payload) => {
  return async (dispatch) => {
    try {
      const resp = await api.patch(`users/id/${id}`, payload, {
        headers: authHeader(),
      });
      await dispatch(actionUsuariosGet());
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo actualizar el usuario");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

export const actionUsuarioDeleteById = (id) => {
  return async (dispatch) => {
    try {
      await api.delete(`users/id/${id}`, { headers: authHeader() });
      await dispatch(actionUsuariosGet());
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo desactivar el usuario");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

export const actionUsuarioPermisosGet = (id) => {
  return async (dispatch) => {
    try {
      const resp = await api.get(`users/id/${id}/permisos`, { headers: authHeader() });
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudieron obtener los permisos");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};

// `puedeSolicitarCambios` (boolean) es el permiso especial; undefined = no cambiarlo.
export const actionUsuarioPermisosUpdate = (id, permisos, puedeSolicitarCambios) => {
  return async (dispatch) => {
    try {
      const body = {
        permisos,
        ...(puedeSolicitarCambios === undefined ? {} : { puede_solicitar_cambios: puedeSolicitarCambios }),
      };
      const resp = await api.put(`users/id/${id}/permisos`, body, { headers: authHeader() });
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudieron guardar los permisos");
      dispatch(fetchUsuariosFailure(msg));
      throw error;
    }
  };
};
